import { ParamParseKey, PathMatch, PathPattern } from '@remix-run/router';
import { useAppContext } from '../context/App.context';
import { useMatch } from 'react-router-dom';

export const useLocalizedMatch = <ParamKey extends ParamParseKey<Path>, Path extends string>(
  pattern: PathPattern<Path> | Path
): PathMatch<ParamKey> | null => {
  const { language } = useAppContext();

  return useMatch(`/${language}${pattern}`);
};
